<template>
     <div>
         <div class="panel panel-default">
           <div class="panel-heading">
               <div style="display: flex; justify-content: space-between; align-items: center;">
                   <span>
                       Conversions
                   </span>
               </div>
           </div>
           <div class="panel-body">
               <div style="overflow-x: auto">
                    <table class="table conversions">
                       <thead>
                           <tr>
                               <th class="campaign-name-cell">Name</th>
                               <th class="tac">Status</th>
                               <th class="tac">Recent</th>
                               <th class="tac">Monitor</th>
                           </tr>
                       </thead>
                       <tbody v-if="loadingConversions">
                           <tr>
                               <td></td>
                               <td class="loading">
                                    <i class="fa fa-refresh fa-spin fa-fw"></i>
                                    <span class="sr-only">Loading...</span>
                               </td>
                               <td></td>
                           </tr>
                       </tbody>
                       <tbody v-if="!loadingConversions">
                           <tr v-for="(conversion, idx) in account.conversions" :key="conversion.id">
                               <td class="campaign-name-cell">
                                   {{ conversion.name }}
                                   <a class="ml-0-5" :href="conversion.url" target="_blank" v-if="conversion.url">
                                       <i class="fa fa-external-link"></i>
                                   </a>
                               </td>
                               <td class="tac">
                                   {{ conversion.active ? 'Active' : 'Inactive' }}
                               </td>
                               <td class="tac">
                                   {{ conversion.recent }}
                               </td>
                               <td class="tac">
                                   <input type="checkbox" v-model="conversion.monitor" @change="toggleMonitor(conversion)">
                               </td>
                           </tr>
                       </tbody>
                    </table>
                </div>
           </div>
         </div>
     </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {

    data() {
        return {
            loadingConversions: true,
            conversions: [],
        }
    },

    computed: {
        ...mapGetters('client',{
            'account': 'activeAdAccount',
            'isAdmin': 'isAdmin',
            'client': 'activeClient',
        })
    },

    created() {
        Bus.$on('load-conversion-list', this.prepareComponent);
    },

    methods: {
        prepareComponent() {
            this.getConversionListForAccount();
        },

        getConversionListForAccount() {
            this.loadingConversions = true;
            this.$store.dispatch('client/getConversionList',{
                filter: this.filter
            }).then((conversions) => {
                this.conversions = conversions;
                this.loadingConversions = false;
            })
            .catch((response) => {
                Bus.$emit('show-error-alert', response.data.message);
            })
        },

        toggleMonitor(conversion) {
            conversion.monitor = conversion.monitor ? 1 : 0;
            this.$store.dispatch('client/toggleConversionMonitor',{
                conversion: conversion
            }).then()
            .catch((response) => {
                Bus.$emit('show-error-alert', response.data.message);
            })
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/AdAccountConversionList.vue